import { QUERY_CONFIGS } from './queryConfigTypes';
import { QueryClientInstance } from './queryClientInstance';
import { createApiFetchFn, getApiUrlComponents, getOrderedQueryKey } from '../../apis-infra';
export const createApiQueryOptions = _ref => {
  var _methodConfig$queryCo;
  let {
    methodConfig
  } = _ref;
  const apiConfig = methodConfig.service;
  const queryConfigType = (_methodConfig$queryCo = methodConfig == null ? void 0 : methodConfig.queryConfigType) != null ? _methodConfig$queryCo : apiConfig.defaultQueryConfigType;
  const queryConfig = queryConfigType ? QUERY_CONFIGS[queryConfigType] : {};
  const fetchFn = createApiFetchFn({
    methodConfig
  });
  return _ref2 => {
    var _methodConfig$keyTran;
    let {
      httpClient,
      request,
      options
    } = _ref2;
    return {
      ...queryConfig,
      ...options,
      queryKey: [...getApiUrlComponents(methodConfig), (_methodConfig$keyTran = methodConfig == null ? void 0 : methodConfig.keyTransform == null ? void 0 : methodConfig.keyTransform(request)) != null ? _methodConfig$keyTran : getOrderedQueryKey(request)],
      queryFn: async () => {
        return fetchFn({
          httpClient,
          request
        });
      }
    };
  };
};
export const invalidateQuery = methodConfig => {
  if (!methodConfig) {
    return;
  }
  QueryClientInstance.Instance.queryClient.invalidateQueries({
    queryKey: getApiUrlComponents(methodConfig),
    exact: false,
    // predicate: (query) =>
    //   query.queryKey[0] === serviceConfig.baseUrl &&
    //   (query.queryKey[1] === methodConfig?.path ||
    //     query.queryKey[1] === methodName),
    refetchActive: true,
    refetchInactive: false
  }).then().catch();
};
//# sourceMappingURL=createApiQueryOptions.js.map